import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './CertificatesSlider.css';
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
const CertificatesSlider = () => {
  return (
    <div className="certificates-section">
      <div className="container">


        <Heading_title
          title="Certifications"
          subtitle="Certified for Excellence, Ready for Success!"
        />

        <Swiper
          className='certificate_swiper'
          modules={[Pagination, Autoplay]}

          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          slidesPerView={4}
          spaceBetween={10}
          loop={true}
          pagination={{ clickable: true }}
          breakpoints={{
            0: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            575: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1199: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
        >
          <SwiperSlide>

            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img1.png" alt="IEC Certificate" className='cetificate_img' />
              </div>

            </div>
          </SwiperSlide>
          <SwiperSlide>

            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img2.png" alt="Partner Certificate" className='cetificate_img' />
              </div>

            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img3.png" alt="Icegate Registration" className='cetificate_img' />
              </div>

            </div>
          </SwiperSlide>


          <SwiperSlide>
            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img5.jpeg" alt="SBI Certificate" className='cetificate_img' />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img6.png" alt="SBI Certificate" className='cetificate_img' />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img7.png" alt="SBI Certificate" className='cetificate_img' />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img8.png" alt="SBI Certificate" className='cetificate_img' />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img9.png" alt="SBI Certificate" className='cetificate_img' />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className='card_holder'>
              <div className="certificate-card">
                <img src="/assets/images/about_us/certificates/img10.jpeg" alt="SBI Certificate" className='cetificate_img' />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default CertificatesSlider;
